import { ChevronNavigation } from '@workspace/ui/common';
import { cn } from '@workspace/lib';

interface ProductSlideshowNavigationProps {
  slidesLength: number;
  onNext: () => void;
  onPrev: () => void;
}

export function ProductSlideshowNavigation({ slidesLength, onNext, onPrev }: ProductSlideshowNavigationProps) {
  if (slidesLength <= 1) return null;

  return <ChevronNavigation goNext={onNext} goPrev={onPrev} className={cn('md:my-0')} />;
}
